import { AnalysisModalController } from '../components/AnalysisModal/AnalysisModalController';
import AnalysisModalView from '../components/AnalysisModal/AnalysisModalView.html';
import { getService } from 'data/function';
export class AnalysisModalProcessor {
    get ModalService() {
        return getService('ModalService');
    }
    open(analysis) {
        this.ModalService.showModal({
            controller: AnalysisModalController,
            controllerAs: '$ctrl',
            template: AnalysisModalView,
            inputs: {
                analysis,
            },
        });
    }
}
